import { Button, Col, Modal, Row, Tooltip } from "antd";
import { useState } from "react";
import AnimalReportColumn from "./AnimalReportColumn";

interface IAnimalReportBarProps {
  report?: any;
}

const AnimalReportBar = (props: IAnimalReportBarProps) => {
  const [earringModalIsOpen, setEarringModalIsOpen] = useState(false);
  const [earringNoData, setEarringNoData] = useState([]);
  return (
    <>
      <Row justify="center">
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Toplam Hayvan">T. HAYVAN</Tooltip>}
            value={props.report?.animalCount}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName="SAĞMAL"
            value={props.report?.milch.value}
            data={props.report?.milch.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName="KURU"
            value={props.report?.dry.value}
            data={props.report?.dry.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName="CLOSE UP"
            value={props.report?.closeup.value}
            data={props.report?.closeup.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName="FRESH"
            value={props.report?.fresh.value}
            data={props.report?.fresh.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Toplam Gebe">T. GEBE</Tooltip>}
            value={props.report?.pregnant.value}
            data={props.report?.pregnant.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName="BOŞ"
            value={props.report?.nonPregnant.value}
            data={props.report?.nonPregnant.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName="BELİRSİZ"
            value={props.report?.none.value}
            data={props.report?.none.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Toplam Buzağı">T. BUZAĞI</Tooltip>}
            value={props.report?.calf.value}
            data={props.report?.calf.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Erkek Buzağı">E. BUZAĞI</Tooltip>}
            value={props.report?.mcalf.value}
            data={props.report?.mcalf.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Dişi Buzağı">D. BUZAĞI</Tooltip>}
            value={props.report?.fcalf.value}
            data={props.report?.fcalf.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Toplam Erkek Dana">T. EDANA</Tooltip>}
            value={props.report?.msteer.value}
            data={props.report?.msteer.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Dişi Dana">D. DANA</Tooltip>}
            value={props.report?.fsteer.value}
            data={props.report?.fsteer.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Boğaaltı Düve">B. DÜVE</Tooltip>}
            value={props.report?.heifer.value}
            data={props.report?.heifer.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Tohumlanmış Düve">T. DÜVE</Tooltip>}
            value={props.report?.seminationHeifer.value}
            data={props.report?.seminationHeifer.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Gebe Düve">G. DÜVE</Tooltip>}
            value={props.report?.pregnantHeifer.value}
            data={props.report?.pregnantHeifer.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Toplam Tosun">T. TOSUN</Tooltip>}
            value={props.report?.bull.value}
            data={props.report?.bull.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName="USG1"
            value={props.report?.usg1.value}
            data={props.report?.usg1.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName="USG2"
            value={props.report?.usg2.value}
            data={props.report?.usg2.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={
              <Tooltip title="Projeksiyon Sağılan Gün Sayısı">pSGS</Tooltip>
            }
            value={props.report?.avgSgs}
            condition={props.report?.avgSgs < 400}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Sağılan Gün Sayısı">SGS</Tooltip>}
            value={props.report?.avgDsg}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={
              <Tooltip title="Ortalama Günlük Süt Verimi">OGSV</Tooltip>
            }
            value={props.report?.ogsv}
            condition={props.report?.ogsv > 25}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={
              <Tooltip title="Gebelik Başına Tohum Sayısı">GBTS</Tooltip>
            }
            value={props.report?.gbts}
            condition={props.report?.gbts < 1.9}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={<Tooltip title="Döl Verim Oranı">DVO</Tooltip>}
            value={props.report?.dvo}
            condition={props.report?.dvo > 70}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={
              <Tooltip title="Senkronizasyona Hazır">Senk. Hazır</Tooltip>
            }
            value={props.report?.readySync.value}
            data={props.report?.readySync.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName="Senkronizasyonda"
            value={props.report?.inSync.value}
            data={props.report?.inSync.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
        <Col>
          <AnimalReportColumn
            columnName={
              <Tooltip title="Bireysel Aşı Havuzu">B. Aşı Havuzu</Tooltip>
            }
            value={props.report?.individualVaccine.value}
            data={props.report?.individualVaccine.data}
            setEarringModalIsOpen={setEarringModalIsOpen}
            setEarringNoData={setEarringNoData}
          />
        </Col>
      </Row>
      <Modal
        title="Küpe Numaraları"
        visible={earringModalIsOpen}
        okButtonProps={{ hidden: true }}
        cancelText="Kapat"
        onCancel={() => {
          setEarringNoData([]);
          setEarringModalIsOpen(false);
        }}
      >
        <Row justify="space-between" align="middle">
          <Button
            type="link"
            onClick={async () => {
              const data = earringNoData
                .map((line: string) => line.split("-").slice(0, 1).join("\t"))
                .join("\n");
              await navigator.clipboard.writeText(data);
            }}
          >
            Küpeleri Kopyala
          </Button>
          <Button
            type="link"
            onClick={async () => {
              const data = earringNoData
                .map((line: string) => line.split("-").slice(1, 2).join("\t"))
                .join("\n");
              await navigator.clipboard.writeText(data);
            }}
          >
            İşletme No'ları Kopyala
          </Button>
          <Button
            type="link"
            onClick={async () => {
              const data = earringNoData
                .map((line: string) => line.split("-").slice(0, 2).join("\t"))
                .join("\n");
              await navigator.clipboard.writeText(data);
            }}
          >
            Her İkisini Kopyala
          </Button>
        </Row>
        {earringNoData.map((earringNo, index) => (
          <div key={index}>
            {earringNo}
            <br />
          </div>
        ))}
      </Modal>
    </>
  );
};

export default AnimalReportBar;
